<template>
  <el-dialog
    :title="$t('member.memberCreate.syncDialog.title')"
    :show-close="true"
    :visible="true"
    :width="width"
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <span>{{ $t('member.memberCreate.syncDialog.syncContent', { orgName: org.name, shopName: shopConfig.name }) }}</span>
    <span slot="footer" class="dialog-footer">
      <div class="flex justify-end" style="gap: 12px">
        <BaseElButton plain @click="$emit('close')">{{ $t('member.memberCreate.syncDialog.back') }}</BaseElButton>
        <BaseElButton :loading="loading" type="primary" @click="registerShopMemberByUser">{{ $t('member.memberCreate.syncDialog.viewDetail') }}</BaseElButton>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { RegisterShopMemberByUser } from '@/api/member'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SyncMemberDialog',

  props: {
    content: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '40%',
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters(['shop']),
    ...mapState('org', ['org']),
    ...mapState('shop', ['shopConfig']),
  },
  methods: {
    async registerShopMemberByUser () {
      this.loading = true
      const [res, err] = await RegisterShopMemberByUser({
        shopId: this.shop,
        userId: this.user.id,
      })
      if (err) {
        this.$message.error(err)
        this.loading = false
        return
      }
      this.$router.push({
        name: 'MemberProfile',
        params: {
          id: res.member.id,
        },
      })
    },
  },
}
</script>

<style lang="postcss" scoped>

</style>
